import axios from 'axios';

export function adminUpdateCampaignContent(adId, payload, token) {
    return axios.put(
        `${process.env.REACT_APP_API_URL}/admin/advertisements/${adId}/content`,
        payload,
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
